var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show_nav_content)?_c('div',{staticClass:"footer-nav"},[_c('buscador',{staticClass:"d-lg-none"}),_c('items-list',{staticClass:"d-none d-lg-flex"})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }